var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationAddFriend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationAddFriend") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,9.6 C12.3786667,9.6 13.3333333,8.64533333 13.3333333,7.46666667 C13.3333333,6.288 12.3786667,5.33333333 11.2,5.33333333 C10.0213333,5.33333333 9.06666667,6.288 9.06666667,7.46666667 C9.06666667,8.64533333 10.0213333,9.6 11.2,9.6 Z M6.4,8.53333333 L6.4,6.93333333 L5.33333333,6.93333333 L5.33333333,8.53333333 L3.73333333,8.53333333 L3.73333333,9.6 L5.33333333,9.6 L5.33333333,11.2 L6.4,11.2 L6.4,9.6 L8,9.6 L8,8.53333333 L6.4,8.53333333 Z M11.2,10.6666667 C9.776,10.6666667 6.93333333,11.3813333 6.93333333,12.8 L6.93333333,13.8666667 L15.4666667,13.8666667 L15.4666667,12.8 C15.4666667,11.3813333 12.624,10.6666667 11.2,10.6666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationAddFriend"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#2C91D0",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/social/person_add_24px",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationAddFriend);
export default __webpack_public_path__ + "static/media/icNotificationAddFriend.56cb265e4c7465afb4ebfc248e862345.svg";
export { ForwardRef as ReactComponent };